module.exports = __webpack_public_path__ + "3cf4016f1477947a4e6fd6391c17a984.jpg";